var collapsibleSectionsAdmin = collapsibleSectionsAdmin || {};
(function($) {

	var GF_EDITOR_VERSION = ( collapsibleSectionsFieldVars.is_gf_min_2_5 !== "" ) ? 2 : 1;
	var GF_MARKUP_VERSION = GF_EDITOR_VERSION;

	collapsibleSectionsAdmin.getSettingsElement = function() {
		var $fieldSettings = $('#field_settings_container');// GF 2.5+
		if ( GF_EDITOR_VERSION === 1 ) {
			// var field = GetSelectedField();
			// $fieldSettings = $('#field_'+field.id).find('#field_settings');
			$fieldSettings = $('#field_settings');// legacy
		}
		return $fieldSettings;
	};

	collapsibleSectionsAdmin.getField = function() {
		var field = GetSelectedField();
		var $field = $('#field_'+field.id);
		return $field;
	};

	collapsibleSectionsAdmin.toggleCollapsibleSections = function(value) {

		var field = GetSelectedField();
		var $field = collapsibleSectionsAdmin.getField();
		var $settings = collapsibleSectionsAdmin.getSettingsElement();

		if ( typeof value === 'undefined' ) {
			value = 'none';
		}

		var $toggle = $settings.find('input.collapsible_sections_toggle[value="'+value+'"]');

		var $title = $field.find('.gfield_admin_header_title');
		var fieldTitle = $title.html();

		var $label = $field.find('.gsection_collapsible');

		SetFieldProperty('collapsibleSections_enableCollapsible', value);


		$toggle.prop('checked', true);

		var $descriptionSetting = $settings.find('.collapsible-sections-field-description-setting');
		var $endSectionDisplay = $settings.find('.collapsible-sections-field-end-display-setting');

		if (value !== 'none') {
			$field.addClass('collapsible-sections-admin-field');
			$settings.addClass('collapsible-sections-field-settings');

			if (value === 'start') {
				if ($descriptionSetting.length) {
					$descriptionSetting.show();
				}
				if ($endSectionDisplay.length) {
					$endSectionDisplay.hide();
				}
			}
			else if (value === 'end') {
				if ($descriptionSetting.length) {
					$descriptionSetting.hide();
				}
				if ($endSectionDisplay.length) {
					$endSectionDisplay.show();
				}
			}

			var titleLabel = (value === 'end') ? 'Collapsible End' : 'Collapsible Start';
			if (!$label.length) {
				$label = $('<div class="gsection_collapsible"></div>').insertBefore( $field.find('.gsection_title') );
			}
			$label.attr('class', 'gsection_collapsible gsection_collapsible_'+value).html('<span>'+titleLabel+'</span>');

			if (field.hasOwnProperty('collapsibleSections_descriptionPlacement') && field.collapsibleSections_descriptionPlacement !== '') {
				collapsibleSectionsAdmin.updateDescriptionSetting(field.collapsibleSections_descriptionPlacement);
			}
			if (field.hasOwnProperty('collapsibleSections_endSectionDisplay') && field.collapsibleSections_endSectionDisplay !== '') {
				collapsibleSectionsAdmin.updateEndSectionDisplaySetting(field.collapsibleSections_endSectionDisplay);
			}
		}
		else {
			$field.removeClass('collapsible-sections-admin-field');
			$field.removeClass('collapsible-sections-description-default');
			$field.removeClass('collapsible-sections-description-inside');
			$field.removeClass('collapsible-sections-description-title');

			$settings.removeClass('collapsible-sections-field-settings');


			if ($label.length) {
				$label.remove();
			}

			if ($descriptionSetting.length) {
				$descriptionSetting.hide();
				var $descriptionSettingSelect = $settings.find('.collapsible-sections-description-placement');
				if ($descriptionSettingSelect.length) {
					$descriptionSettingSelect.val('form_setting').trigger('change');
				}
			}

			if ($endSectionDisplay.length) {
				$endSectionDisplay.hide();
				var $endSectionDisplaySelect = $settings.find('.collapsible-sections-field-end-display');
				if ($endSectionDisplaySelect.length) {
					$endSectionDisplaySelect.val('default').trigger('change');
				}
			}
		}

	};


	collapsibleSectionsAdmin.updateEndSectionDisplaySetting = function( setting ) {
		SetFieldProperty('collapsibleSections_endSectionDisplay', setting);
	};

	collapsibleSectionsAdmin.updateDescriptionSetting = function( setting ) {
		SetFieldProperty('collapsibleSections_descriptionPlacement', setting);

		var field = GetSelectedField();
		var $field = $('#field_'+field.id);

		$field.removeClass('collapsible-sections-description-default');
		$field.removeClass('collapsible-sections-description-inside');
		$field.removeClass('collapsible-sections-description-title');

		$field.addClass('collapsible-sections-description-'+setting);
	};


	$(document).bind('gform_load_field_settings', function (event, gfield, form) {

		GF_MARKUP_VERSION = (form.hasOwnProperty('markupVersion') && form.markupVersion !== '') ? form.markupVersion : 1;

		var $settings = collapsibleSectionsAdmin.getSettingsElement();// $('#field_'+gfield.id + ' #field_settings');

		if (gfield.type === 'section') {

			if ( GF_EDITOR_VERSION === 2 ) {
				$('#collapsible_sections_tab_toggle').show();
			}

			var collapsibleValue = (typeof gfield.collapsibleSections_enableCollapsible !== 'undefined') ? gfield.collapsibleSections_enableCollapsible : 'none';
			if (collapsibleValue === true) {
				collapsibleValue = 'start';
			}
			else if (collapsibleValue === false) {
				collapsibleValue = 'none';
			}


			var $toggle = $settings.find('input.collapsible_sections_toggle[value="'+collapsibleValue+'"]');
			if ($toggle.length) {
				$toggle.prop('checked', true);
			}

			if (collapsibleValue === 'start') {
				$settings.find('.collapsible-sections-field-description-setting').show();
			}
			else if (collapsibleValue === 'end') {
				$settings.find('.collapsible-sections-field-end-display-setting').show();
			}


			$settings.find('.collapsible-sections-field-toggle-setting').show();
			collapsibleSectionsAdmin.toggleCollapsibleSections( collapsibleValue );

			var endSectionDisplay = (gfield.collapsibleSections_endSectionDisplay !== undefined) ? gfield.collapsibleSections_endSectionDisplay : 'default';
			var $endSectionDisplaySelect = $settings.find('.collapsible-sections-field-end-display');
			$endSectionDisplaySelect.val(endSectionDisplay);
			if ($endSectionDisplaySelect.find('option[selected]').length) {
				$endSectionDisplaySelect.find('option[selected]').removeAttr('selected');
			}
			$endSectionDisplaySelect.find('option[value="'+endSectionDisplay+'"]').prop('selected', true);
			collapsibleSectionsAdmin.updateEndSectionDisplaySetting(endSectionDisplay);


			var descriptionPlacement = (gfield.collapsibleSections_descriptionPlacement !== undefined) ? gfield.collapsibleSections_descriptionPlacement : 'form_setting';
			var $descriptionPlacementSelect = $settings.find('.collapsible-sections-description-placement');
			$descriptionPlacementSelect.val(descriptionPlacement);
			if ($descriptionPlacementSelect.find('option[selected]').length) {
				$descriptionPlacementSelect.find('option[selected]').removeAttr('selected');
			}
			$descriptionPlacementSelect.find('option[value="'+descriptionPlacement+'"]').prop('selected', true);
			collapsibleSectionsAdmin.updateDescriptionSetting(descriptionPlacement);

			if (typeof window.gform_initialize_tooltips === 'function') {
				window.gform_initialize_tooltips();
			}

		}
		else {

			collapsibleSectionsAdmin.toggleCollapsibleSections('none');

			if ( GF_EDITOR_VERSION === 2 ) {
				setTimeout(function(){
					$('#collapsible_sections_tab_toggle').hide();
				}, 10);
			}

		}

	});


	$(document).ready(function(e){

		if ( typeof form !== 'undefined' && form.hasOwnProperty('markupVersion') ) {
			GF_MARKUP_VERSION = (form.markupVersion !== '') ? form.markupVersion : 1;
		}

		if (typeof form !== 'undefined' && form.hasOwnProperty('fields')) {
			$.each(form.fields, function(i, field){
				if (field.type === 'section' && field.hasOwnProperty('collapsibleSections_enableCollapsible') && field.collapsibleSections_enableCollapsible !== 'none') {
					var enabledValue = field.collapsibleSections_enableCollapsible;
					var $field = $('#field_'+field.id);
					if ($field.length) {
						var $label = $field.find('.gsection_collapsible');
						if (!$label.length) {
							var titleLabel = (enabledValue === 'end') ? 'Collapsible End' : 'Collapsible Start';
							$field.find('.gsection_title').before('<div class="gsection_collapsible gsection_collapsible_'+enabledValue+'"><span>'+titleLabel+'</span></div>');
						}
					}
				}
			});
		}

		// Form settings
		var $formSettings = (GF_EDITOR_VERSION === 1) ? $('.gform_panel_form_settings#form_settings') : $('.gform-settings__content#tab_gf-collapsible-sections');
		if ($formSettings.length) {

			var $forceSingleOpenCheckbox = $formSettings.find('input[name="gf_collapsible_sections_force_single_opens"]');
			var $singleOpenSettingRow = (GF_EDITOR_VERSION === 1) ? $formSettings.find('#gaddon-setting-row-gf_collapsible_sections_single_open_by_default') : $formSettings.find('#gform_setting_gf_collapsible_sections_single_open_by_default');
			var $multipleOpenSettingRow = (GF_EDITOR_VERSION === 1) ? $formSettings.find('#gaddon-setting-row-gf_collapsible_sections_open_by_default') : $formSettings.find('#gform_setting_gf_collapsible_sections_open_by_default');
			$forceSingleOpenCheckbox.on('change', function(){
				if ($(this).is(':checked')) {
					$singleOpenSettingRow.show();
					$multipleOpenSettingRow.hide();
				}
				else {
					$singleOpenSettingRow.hide();
					$multipleOpenSettingRow.show();
				}
			});
			$forceSingleOpenCheckbox.trigger('change');

			var $autoScrollCheckbox = $formSettings.find('input[name="gf_collapsible_sections_scroll_to"]');
			var $scrollOffsetSettingRow = (GF_EDITOR_VERSION === 1) ? $formSettings.find('#gaddon-setting-row-gf_collapsible_sections_scroll_to_offset') : $formSettings.find('#gform_setting_gf_collapsible_sections_scroll_to_offset');
			var $scrollDurationSettingRow = (GF_EDITOR_VERSION === 1) ? $formSettings.find('#gaddon-setting-row-gf_collapsible_sections_scroll_to_duration') : $formSettings.find('#gform_setting_gf_collapsible_sections_scroll_to_duration');

			/*
			if ($scrollOffsetSettingRow.length) {
				$scrollOffsetSettingRow.find('input').attr('type', 'number').attr('step', 1).attr('min', 0);
			}
			if ($scrollDurationSettingRow.length) {
				$scrollDurationSettingRow.find('input').attr('type', 'number').attr('step', 1).attr('min', 0);
			}
			*/

			$autoScrollCheckbox.on('change', function(){
				if ($(this).is(':checked')) {
					if ($scrollOffsetSettingRow.length) {
						$scrollOffsetSettingRow.show();
					}
					if ($scrollDurationSettingRow.length) {
						$scrollDurationSettingRow.show();
					}
				}
				else {
					if ($scrollOffsetSettingRow.length) {
						$scrollOffsetSettingRow.hide();
					}
					if ($scrollDurationSettingRow.length) {
						$scrollDurationSettingRow.hide();
					}
				}
			});
			$autoScrollCheckbox.trigger('change');

		}


		var $customCssGlobalTextarea = $('#gf_collapsible_sections_custom_css_global');
		var editor;
		if ($customCssGlobalTextarea.length) {

			$customCssGlobalTextarea.after('<div id="gf_collapsible_sections_custom_css_global_editor">'+$customCssGlobalTextarea.text()+'</div>');
			editor = ace.edit("gf_collapsible_sections_custom_css_global_editor");
			editor.setOptions({
				showInvisibles : false,
				showGutter: true,
				showLineNumbers: true,
				displayIndentGuides: false,
				scrollPastEnd: false,
				theme: 'ace/theme/xcode'
			});
			//editor.setTheme("ace/theme/xcode");
			editor.session.setMode("ace/mode/css");

			editor.getSession().on("change", function () {
				$customCssGlobalTextarea.val(editor.getSession().getValue());
			});

		}

		var $customCssFormTextarea = $('#gf_collapsible_sections_custom_css');
		if ($customCssFormTextarea.length) {

			$customCssFormTextarea.after('<div id="gf_collapsible_sections_custom_css_editor">'+$customCssFormTextarea.text()+'</div>');
			editor = ace.edit("gf_collapsible_sections_custom_css_editor");
			editor.setOptions({
				showInvisibles : false,
				showGutter: true,
				showLineNumbers: true,
				showFoldWidgets: false,
				displayIndentGuides: false,
				scrollPastEnd: false,
				theme: 'ace/theme/xcode'
			});
			//editor.setTheme("ace/theme/xcode");
			editor.session.setMode("ace/mode/css");

			editor.getSession().on("change", function () {
				$customCssFormTextarea.val(editor.getSession().getValue());
			});

		}

	});

})(jQuery);
